import { LoadingOutlined, ScheduleOutlined } from '@ant-design/icons';
import { Card, Spin } from 'antd';
import React, { useState } from 'react'
import HolidaysService from '../../Services/HolidaysService';
import dayjs, { Dayjs } from 'dayjs';
import { Link, useNavigate } from 'react-router-dom';
import { EmptyIcon } from '../../Common/FullPageSpinner';
import { DBRecordStatus } from '../../Common/CommonComponent';

interface IProps {
    fromDate: string,
    toDate: string
}

interface HolidayRes {
    date: Dayjs | string,
    id: string,
    name: string,
    sno: number
}

const HolidayCard = ({ fromDate, toDate }: IProps) => {
    // const [holidayFilter, setHolidayFilter] = useState<'Upcoming' | 'Previous'>('Upcoming');
    const [holidayData, setHolidayData] = useState<HolidayRes[]>([])
    const [totalHoliday, setTotalHoliday] = useState(0);
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    // const filteredHolidays = holidaysData.filter((holiday) => {
    //     const holidayDate = new Date(holiday.date.split('/').reverse().join('-')); // Convert DD/MM/YYYY to YYYY-MM-DD
    //     if (holidayFilter === 'Upcoming') {
    //         return holidayDate >= currentDate;
    //     } else {
    //         return holidayDate < currentDate;
    //     }
    // });

    const getHolidayDetails = async () => {
        try {
            setLoading(true);
            const res = await HolidaysService.getUpdatesList(0, 5, "", DBRecordStatus.Active, fromDate, toDate, "Date", "descend")
            if (res?.result && res?.status) {
                setHolidayData(res?.result?.items)
                setTotalHoliday(res?.result?.totalRecords || 0)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        getHolidayDetails();
    }, [fromDate, toDate])

    return (
        <Card
            title={<span className="fs15 fw600">Holidays <span className="px-2 ms-1" style={{ background: '#377DFF', height: 17, color: '#ffffff', fontSize: 13, borderRadius: 10 }}>{totalHoliday}</span></span>}
            // style={{ minHeight: 538 }}
            style={{
                width: "100%",
                maxHeight: 538,
                display: "flex",
                flexDirection: "column"
            }}
            styles={{
                body: {
                    padding: "10px 16px 4px 16px",
                    overflowY: "auto",
                    flex: 1
                }
            }}
            extra={
                <>
                    {/* <Select
                        placeholder="Select"
                        className="select-height-28"
                        defaultValue={{ label: 'Upcoming', value: 'Upcoming' }}
                        options={[
                            { label: 'Upcoming', value: 'Upcoming' },
                            { label: 'Previous', value: 'Previous' },
                        ]}
                        style={{ width: 120, marginRight: 10 }}
                    /> */}
                    <Link style={{ color: '#377DFF' }} to="/holidays" target="_blank">View All</Link>
                    {/* <Button type="link" style={{ fontSize: 13 }} onClick={() => {
                    navigate("/holidays")
                  }}>View All</Button> */}
                </>
            }
        >
            <Spin
                spinning={loading}
                indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {holidayData.map((holiday) => (
                        <div
                            key={holiday?.id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 16px',
                                backgroundColor: '#f1f5f998',
                                borderRadius: 8,
                                border: '1px solid #F0F0F0',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: '20%',
                                        backgroundColor: '#dbeafe',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <ScheduleOutlined size={20} color="#1677FF" />
                                </div>
                                <div className="fs14 fw600" style={{ color: 'rgba(0, 0, 0, 0.75)' }}>
                                    {holiday.name}

                                </div>
                            </div>
                            <div style={{ fontSize: 14, color: '#1677FF', fontWeight: 500 }}>
                                {dayjs(holiday?.date).format("DD/MM/YYYY")}
                            </div>
                        </div>
                    ))}
                    {holidayData.length === 0 && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20, gap: 8 }}>
                            <EmptyIcon />
                        </div>

                    )}
                </div>
            </Spin>
        </Card>
    )
}

export default HolidayCard